import styled from '@emotion/styled';
import * as React from 'react';

import theme from '@travelnest/merlin.theme';
import { Label } from '@travelnest/merlin.typography';
import { ICalendarEvent } from '../../components/calendar/types';
import { BreakpointType } from './Calendar';
import { DateRange } from './calendar-helpers';

import { dateDiff, ordinal } from './calendar-helpers';

const StyledEventSelection = styled.div`
	background-image: url("/92b3b47/assets/icons/calendar/green.svg");
	background-repeat: no-repeat;
	background-position: top -80px left -90px;
	padding: ${theme.layout.spacing.large};
	color: ${theme.colours.text.darker};
	overflow: hidden;
`;

const StyledEventSelectionBottomRightBackgroundImage = styled.div<{ inContextOverlay: boolean, hasSelection: boolean }>`
	background: #e6f7f0;
	background-image: url("/92b3b47/assets/icons/calendar/green.svg");
	background-repeat: no-repeat;
	background-position: bottom -80px right -80px;
	border-radius: ${({ inContextOverlay }) => inContextOverlay ? '0px' : theme.layout.radius.default};
	border-bottom-right-radius: ${({ inContextOverlay, hasSelection }) => inContextOverlay ? '0px' : hasSelection ? '0px' : theme.layout.radius.default};
	border-bottom-left-radius: ${({ inContextOverlay, hasSelection }) => inContextOverlay ? '0px' : hasSelection ? '0px' : theme.layout.radius.default};
	overflow: hidden;
`;

const StyledNightsSelectedBox = styled.div`
	justify-content: space-between;
	background: #fff;
	padding: ${theme.layout.spacing.standard} ${theme.layout.spacing.large};
	border-radius: ${theme.layout.radius.default};
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
	font-weight: ${theme.typography.c1.fontWeight};
`;

const formatDate = (d: Date) => {
	const date = ordinal(d.getDate());
	const month = d.toLocaleString('default', { month: 'short' });
	const year = d.getFullYear();
	return `${date} ${month} ${year}`;
};

const StyledDateSelectionContainer = styled.div`
	font-size: .875rem;
	margin: 10px 0 0;


	display: grid;
	grid-template-columns: 13ch 2ch 13ch;
`;

interface IEventSelectionMessageProps {
	eventsInSelection?: Array<ICalendarEvent | undefined>;
	nights: number;
	/**
	 * If true, the selection message will only show the number of nights selected.
	 */
	breakpoint: BreakpointType;
	nightsOnly?: boolean;
	inContextPanel?: boolean;
	dateRanges: DateRange[];
}

export const SelectionSummary: React.FC<IEventSelectionMessageProps> = (
	{ nights, breakpoint, inContextPanel, dateRanges }
) => <StyledEventSelectionBottomRightBackgroundImage
	inContextOverlay={!!inContextPanel && breakpoint === 'mobile'}
	hasSelection={!!nights}
>
		<StyledEventSelection>
			<StyledNightsSelectedBox>
				<Label data-testid="event-selection-nights" htmlFor="">{nights} night{nights === 1 ? '' : 's'} selected</Label>
				{dateRanges.map((range) => {
					const same = dateDiff(...range) === 0;
					return <StyledDateSelectionContainer data-testid="date-selection" >
						<span>{formatDate(range[0])}</span><span>{!same && '-'}</span> <span> {!same && formatDate(range[1])}</span>
					</StyledDateSelectionContainer>;
				})}
			</StyledNightsSelectedBox>
		</StyledEventSelection>
	</StyledEventSelectionBottomRightBackgroundImage>;
